import React from 'react'
import Settings from '../../components/Settings/Settings'
import './settings.css'
const SettingsMainPage = () => {
  return (
    <div>
       <Settings/>
    </div>
  )
}

export default SettingsMainPage
